"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StatusPage = void 0;
require("core-js/modules/es.array.concat.js");
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _LoginForm = _interopRequireDefault(require("./components/LoginForm.vue"));
var _SignUpForm = _interopRequireDefault(require("./components/SignUpForm.vue"));
var _settings = require("@/settings");
var _Logo = _interopRequireDefault(require("@/layout/components/Sidebar/Logo.vue"));
var StatusPage;
(function (StatusPage) {
  StatusPage["LoginSocial"] = "LoginSocial";
  StatusPage["LoginEmail"] = "LoginEmail";
  StatusPage["SignUp"] = "SignUp";
})(StatusPage || (exports.StatusPage = StatusPage = {}));
var AuthPage = /*#__PURE__*/function (_Vue) {
  function AuthPage() {
    var _this;
    (0, _classCallCheck2.default)(this, AuthPage);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, AuthPage, [].concat(args));
    (0, _defineProperty2.default)(_this, "status", StatusPage.LoginEmail);
    (0, _defineProperty2.default)(_this, "StatusPage", StatusPage);
    (0, _defineProperty2.default)(_this, "title", _settings.title);
    (0, _defineProperty2.default)(_this, "logo", require("@/assets/images/logo.png"));
    return _this;
  }
  (0, _inherits2.default)(AuthPage, _Vue);
  return (0, _createClass2.default)(AuthPage, [{
    key: "handleChangeStatus",
    value: function handleChangeStatus(status) {
      this.status = status;
    }
  }]);
}(_vuePropertyDecorator.Vue);
AuthPage = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    LoginForm: _LoginForm.default,
    SignUpForm: _SignUpForm.default,
    Logo: _Logo.default
  }
})], AuthPage);
var _default = exports.default = AuthPage;